<template>
  <div style="padding-top:40px">
  <div class="win" :style="'background-image:url('+oss+data.style.backgroundImage+');background-size:100%;background-color:'+data.style.backgroundColor">
    <div class="head" :style="'color:'+data.style.titleColor">
      请填写收货地址
    </div>
    <div class="main" :style="'color:'+data.style.color">
        <div class="input">请输入收货人姓名</div>
        <div class="input">请输入收货人手机号</div>
        <div class="input">省、市、区、街道</div>
        <div class="input">小区楼栋/乡村名称</div>
      <div class="button" :style="'background-image:url('+oss+data.style.backgroundButtomImage+');background-size:100%;background-color:'+data.style.buttonColor+';color:'+data.style.buttonTextColor">领取奖品</div>
    </div>
  </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "collect",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  width: 300px;
  height: 407px;
  margin: 0 auto;
  position: relative;
  background-color: #fff;
  border-radius: 10px;
  padding:15px;
  .head {
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .main {
    width: 100%;
    font-size: 15px;
    .input{
      height: 46px;
      line-height: 46px;
      background-color: #F8F8F8;
      padding-left: 15px;
      font-size: 14px;
      color: #999;
      margin-bottom: 16px;
       border-radius: 6px;
    }
    .button {
      width: 150px;
      height: 44px;
      background: #FF0E41;
      border-radius: 22px;
      text-align: center;
      line-height: 44px;
      color: #fff;
      margin: 0 auto;
      margin-top: 40px;
    }
  }
}
</style>